{
  "familyId": "REK-HANDIG-PLUS-MIN",
  "questions": [
    {
      "id": "REK-HANDIG-PLUS-MIN-M01",
      "familyId": "REK-HANDIG-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "handig",
      "subSkill": "handig_optellen_aftrekken",
      "questionType": "multiple_choice",
      "question": "Reken handig uit: 48 + 37. Welke manier is het handigst?",
      "options": [
        "Splitsen: 48 + 30 = 78, dan 78 + 7 = 85",
        "Cijferend: 8 + 7 = 15, schrijf 5, onthoud 1, 4 + 3 + 1 = 8 → 85",
        "Allebei optellen bij 40: 40 + 30 = 70, dan 8 + 7 = 15, samen 85",
        "Compenseren: 48 + 40 = 88, dan 88 − 3 = 85"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "splitDiagram",
          "showWhen": "wrong",
          "data": {
            "original": 37,
            "parts": [{ "value": 30, "label": "tientallen" }, { "value": 7, "label": "eenheden" }],
            "operation": "add",
            "operand": 48,
            "result": 85,
            "label": "Splits 37 in 30 + 7"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Splitsen — handig optellen",
            "content": "Bij splitsen verdeel je één getal in tientallen en eenheden. 48 + 37: splits 37 in 30 + 7. Eerst: 48 + 30 = 78. Dan: 78 + 7 = 85. Dit is sneller dan cijferend rekenen!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_splitsen_optellen",
      "variantIndex": 1,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.strategy-suboptimal", "label": "Kiest cijferend i.p.v. splitsen", "optionIndex": 1 },
          { "id": "rek.strategy-suboptimal", "label": "Kiest beide splitsen i.p.v. één getal splitsen", "optionIndex": 2 },
          { "id": "rek.strategy-suboptimal", "label": "Kiest compenseren waar splitsen handiger is", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Splitsen is hier het handigst: splits 37 in 30 + 7. Eerst 48 + 30 = 78, dan 78 + 7 = 85. Alle vier de manieren geven het juiste antwoord (85), maar splitsen is het snelst omdat je in twee stappen klaar bent.",
        "solutionSteps": [
          "Kies een handige manier: splitsen (37 = 30 + 7)",
          "Stap 1: 48 + 30 = 78",
          "Stap 2: 78 + 7 = 85"
        ],
        "distractorExplanations": {
          "0": "Goed! Splitsen is hier de handigste manier. In twee stappen ben je klaar: 48 + 30 = 78, dan 78 + 7 = 85.",
          "1": "Cijferend rekenen geeft het juiste antwoord, maar is niet 'handig rekenen'. Bij handig rekenen gebruik je slimme trucs die sneller zijn dan de standaard manier.",
          "2": "Beide getallen splitsen werkt ook, maar is meer werk: je moet 40 + 30 = 70 en 8 + 7 = 15 apart uitrekenen en dan optellen. Splitsen van alleen het tweede getal is sneller.",
          "3": "Compenseren (48 + 40 − 3) werkt, maar is hier niet de handigste keuze. Compenseren is vooral handig als een getal dicht bij een tiental ligt, zoals 48 + 39 (→ 48 + 40 − 1)."
        }
      }
    },
    {
      "id": "REK-HANDIG-PLUS-MIN-M02",
      "familyId": "REK-HANDIG-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "handig",
      "subSkill": "handig_optellen_aftrekken",
      "questionType": "multiple_choice",
      "question": "Reken handig uit: 63 − 28. Welke manier is het handigst?",
      "options": [
        "Splitsen: 63 − 20 = 43, dan 43 − 8 = 35",
        "Cijferend: 13 − 8 = 5, 5 − 2 = 3 → 35",
        "Compenseren: 63 − 30 = 33, dan 33 + 2 = 35",
        "Rijgen: 63 − 3 = 60, dan 60 − 25 = 35"
      ],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Compenseren — handig aftrekken",
            "content": "Bij compenseren rond je af naar een handig getal. 28 is bijna 30. Trek 30 af: 63 − 30 = 33. Je hebt 2 te veel afgetrokken, dus tel 2 erbij: 33 + 2 = 35.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_compenseren_aftrekken",
      "variantIndex": 2,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.strategy-suboptimal", "label": "Kiest splitsen waar compenseren handiger is", "optionIndex": 0 },
          { "id": "rek.strategy-suboptimal", "label": "Kiest cijferend i.p.v. compenseren", "optionIndex": 1 },
          { "id": "rek.strategy-suboptimal", "label": "Kiest rijgen i.p.v. compenseren", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Compenseren is hier het handigst: 28 is bijna 30. Trek 30 af: 63 − 30 = 33. Je hebt 2 te veel afgetrokken, dus tel 2 erbij: 33 + 2 = 35. Compenseren werkt het best als een getal dicht bij een tiental ligt.",
        "solutionSteps": [
          "Herken: 28 is bijna 30 → compenseren",
          "Stap 1: 63 − 30 = 33",
          "Stap 2: 33 + 2 = 35 (je trok 2 te veel af)"
        ],
        "distractorExplanations": {
          "0": "Splitsen werkt ook, maar 43 − 8 is lastiger hoofdrekenen dan 33 + 2. Compenseren is hier sneller omdat 28 dicht bij 30 ligt.",
          "1": "Cijferend rekenen geeft het juiste antwoord, maar is niet 'handig rekenen'. Het doel is om een slimmere strategie te kiezen.",
          "2": "Goed! Compenseren is hier het handigst. 28 ≈ 30, dus 63 − 30 = 33, plus 2 terug = 35.",
          "3": "Rijgen (63 − 3 = 60, dan 60 − 25 = 35) werkt, maar je moet 28 splitsen in 3 + 25, wat niet voor de hand ligt. Compenseren naar 30 is logischer."
        }
      }
    },
    {
      "id": "REK-HANDIG-PLUS-MIN-M04",
      "familyId": "REK-HANDIG-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "handig",
      "subSkill": "handig_optellen_aftrekken",
      "questionType": "multiple_choice",
      "question": "Reken handig uit: 99 + 56. Welke manier is het handigst?",
      "options": [
        "Splitsen: 99 + 50 = 149, dan 149 + 6 = 155",
        "Compenseren: 100 + 56 = 156, dan 156 − 1 = 155",
        "Cijferend: 9 + 6 = 15, schrijf 5, 9 + 5 + 1 = 15 → 155",
        "Rijgen: 99 + 1 = 100, dan 100 + 55 = 155"
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Compenseren bij bijna-tientallen",
            "content": "99 is bijna 100! Reken: 100 + 56 = 156. Je hebt 1 te veel opgeteld, dus trek 1 af: 156 − 1 = 155. Compenseren is ideaal als een getal dicht bij een rond getal ligt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_compenseren_optellen",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.70,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.strategy-suboptimal", "label": "Kiest splitsen waar compenseren handiger is", "optionIndex": 0 },
          { "id": "rek.strategy-suboptimal", "label": "Kiest cijferend i.p.v. compenseren", "optionIndex": 2 },
          { "id": "rek.strategy-suboptimal", "label": "Kiest rijgen i.p.v. compenseren", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "99 is bijna 100 — compenseren is hier ideaal! 100 + 56 = 156, min 1 = 155. Compenseren werkt het best als een getal dicht bij een rond getal ligt (99 ≈ 100, 198 ≈ 200, 47 ≈ 50).",
        "solutionSteps": [
          "Herken: 99 is bijna 100 → compenseren",
          "Stap 1: 100 + 56 = 156",
          "Stap 2: 156 − 1 = 155 (je telde 1 te veel op)"
        ],
        "distractorExplanations": {
          "0": "Splitsen werkt ook, maar 99 + 50 = 149 is lastiger dan 100 + 56 = 156. Compenseren naar 100 maakt het makkelijker.",
          "1": "Goed! 99 ≈ 100, dus 100 + 56 = 156, min 1 = 155. Compenseren is hier de snelste manier.",
          "2": "Cijferend rekenen geeft het juiste antwoord, maar is niet 'handig'. Bij handig rekenen zoek je een slimmere weg.",
          "3": "Rijgen (99 + 1 = 100, dan 100 + 55) is eigenlijk ook compenseren, maar dan in twee stappen. De eerste optie is dezelfde manier in één denkstap."
        }
      }
    },
    {
      "id": "REK-HANDIG-PLUS-MIN-004",
      "familyId": "REK-HANDIG-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "handig",
      "subSkill": "handig_optellen_aftrekken",
      "questionType": "fill_in",
      "question": "Reken handig uit: 298 + 47",
      "options": [],
      "correctAnswer": "345",
      "data": {
        "acceptedAnswers": ["345"]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Compenseren: 298 ≈ 300",
            "content": "298 is bijna 300. Reken: 300 + 47 = 347. Je telde 2 te veel op, dus trek 2 af: 347 − 2 = 345.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_compenseren_driehonderd",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "298 is bijna 300 — compenseren! 300 + 47 = 347. Je telde 2 te veel op: 347 − 2 = 345. Dit is veel sneller dan cijferend rekenen.",
        "solutionSteps": [
          "Herken: 298 ≈ 300 → compenseren",
          "300 + 47 = 347",
          "347 − 2 = 345 (2 te veel opgeteld)"
        ]
      }
    },
    {
      "id": "REK-HANDIG-PLUS-MIN-005",
      "familyId": "REK-HANDIG-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "handig",
      "subSkill": "handig_optellen_aftrekken",
      "questionType": "multiple_choice",
      "question": "Je spaart stickers. Je hebt al 145 stickers en je koopt er nog 87 bij. Hoeveel stickers heb je nu in totaal? Reken handig.",
      "options": ["222 liter", "242 liter", "230 liter", "232 liter"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Splitsen in context",
            "content": "145 + 87: splits 87 in 80 + 7. Eerst: 145 + 80 = 225. Dan: 225 + 7 = 232. Of compenseer: 145 + 90 = 235, min 3 = 232.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_context_optellen",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.partial-calculation", "label": "Vergeet eenheden op te tellen: 145+80=225→222", "optionIndex": 0 },
          { "id": "rek.strategy-wrong-correction", "label": "Compenseert verkeerde kant op: +90 dan +7 i.p.v. −3", "optionIndex": 1 },
          { "id": "rek.context-wrong-data", "label": "Gebruikt 85 i.p.v. 87", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "145 + 87: splits 87 in 80 + 7. Eerst 145 + 80 = 225, dan 225 + 7 = 232. Of compenseer: 87 ≈ 90, dus 145 + 90 = 235, min 3 = 232 stickers.",
        "solutionSteps": [
          "Herken de bewerking: 145 + 87",
          "Strategie 1 (splitsen): 145 + 80 = 225, dan 225 + 7 = 232",
          "Strategie 2 (compenseren): 145 + 90 = 235, dan 235 − 3 = 232"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk 145 + 80 = 225, maar vergat de 7 erbij te tellen. 225 − 3 = 222 klopt niet — je moet 225 + 7 = 232 rekenen.",
          "1": "Je dacht waarschijnlijk 145 + 90 = 235, plus 7 = 242. Maar als je 90 optelt in plaats van 87, heb je 3 te veel opgeteld. Trek 3 af: 235 − 3 = 232.",
          "2": "Je dacht waarschijnlijk 145 + 85 = 230. Maar het is 87, niet 85. 145 + 87 = 232.",
          "3": "Goed! 145 + 87 = 232 stickers. Splitsen of compenseren — beide werken hier goed."
        }
      }
    },
    {
      "id": "REK-HANDIG-PLUS-MIN-M06",
      "familyId": "REK-HANDIG-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "handig",
      "subSkill": "handig_optellen_aftrekken",
      "questionType": "multiple_choice",
      "question": "Reken handig uit met splitsen: 56 + 28. Wat is de uitkomst?",
      "options": ["84", "74", "82", "94"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "splitDiagram",
          "showWhen": "wrong",
          "data": {
            "original": 28,
            "parts": [{ "value": 20, "label": "tientallen" }, { "value": 8, "label": "eenheden" }],
            "operation": "add",
            "operand": 56,
            "result": 84,
            "label": "Splits 28 in 20 + 8"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Splitsen — handig optellen",
            "content": "Splits 28 in 20 + 8. Eerst: 56 + 20 = 76. Dan: 76 + 8 = 84.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_splitsen_optellen_56_28",
      "variantIndex": 6,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.partial-calculation", "label": "Vergeet eenheden: 56+20=76 maar stopt daar", "optionIndex": 1 },
          { "id": "rek.context-wrong-data", "label": "Gebruikt 26 i.p.v. 28", "optionIndex": 2 },
          { "id": "rek.strategy-wrong-correction", "label": "Compenseert verkeerde kant op", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Splits 28 in 20 + 8. Eerst 56 + 20 = 76, dan 76 + 8 = 84. Door het tweede getal te splitsen in tientallen en eenheden reken je in twee makkelijke stappen.",
        "solutionSteps": [
          "Splits het tweede getal: 28 = 20 + 8",
          "Stap 1: 56 + 20 = 76",
          "Stap 2: 76 + 8 = 84"
        ],
        "distractorExplanations": {
          "0": "Goed! 56 + 28 = 84. Splitsen: 56 + 20 = 76, dan 76 + 8 = 84.",
          "1": "Je vergat waarschijnlijk de eenheden: 56 + 20 = 76, maar je moet nog 8 erbij tellen. 76 + 8 = 84, niet 74.",
          "2": "Je rekende waarschijnlijk 56 + 26 = 82. Maar het is 28, niet 26. Controleer: 56 + 28 = 84.",
          "3": "Je telde waarschijnlijk 56 + 30 = 86 en dan nog 8 erbij. Maar als je 30 optelt, heb je 2 te veel. 56 + 28 = 84."
        }
      }
    },
    {
      "id": "REK-HANDIG-PLUS-MIN-M07",
      "familyId": "REK-HANDIG-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "handig",
      "subSkill": "handig_optellen_aftrekken",
      "questionType": "multiple_choice",
      "question": "Reken handig uit met splitsen: 83 − 45. Wat is de uitkomst?",
      "options": ["38", "42", "48", "28"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "splitDiagram",
          "showWhen": "wrong",
          "data": {
            "original": 45,
            "parts": [{ "value": 40, "label": "tientallen" }, { "value": 5, "label": "eenheden" }],
            "operation": "subtract",
            "operand": 83,
            "result": 38,
            "label": "Splits 45 in 40 + 5"
          }
        }
      ],
      "conceptId": "handig_splitsen_aftrekken_83_45",
      "variantIndex": 7,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.partial-calculation", "label": "Stopt na eerste stap: 83−40=43 maar vergeet −5", "optionIndex": 1 },
          { "id": "rek.context-wrong-data", "label": "Gebruikt 35 i.p.v. 45", "optionIndex": 2 },
          { "id": "rek.strategy-wrong-correction", "label": "Compenseert verkeerde kant op: −50 dan −5 i.p.v. +5", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Splits 45 in 40 + 5. Eerst 83 − 40 = 43, dan 43 − 5 = 38. Door het af te trekken getal te splitsen, reken je in twee eenvoudige stappen.",
        "solutionSteps": [
          "Splits het af te trekken getal: 45 = 40 + 5",
          "Stap 1: 83 − 40 = 43",
          "Stap 2: 43 − 5 = 38"
        ],
        "distractorExplanations": {
          "0": "Goed! 83 − 45 = 38. Splitsen: 83 − 40 = 43, dan 43 − 5 = 38.",
          "1": "Je rekende waarschijnlijk 83 − 40 = 43, maar vergat dan 5 af te trekken. Of je trok maar 1 af: 43 − 1 = 42. Het moet 43 − 5 = 38 zijn.",
          "2": "Je rekende waarschijnlijk 83 − 35 = 48. Maar het is 45, niet 35. Controleer: 83 − 45 = 38.",
          "3": "Je trok waarschijnlijk te veel af: 83 − 50 = 33, dan 33 − 5 = 28. Maar als je 50 aftrekt, heb je 5 te veel afgetrokken. Je moet 5 er weer bij optellen: 33 + 5 = 38."
        }
      }
    },
    {
      "id": "REK-HANDIG-PLUS-MIN-M08",
      "familyId": "REK-HANDIG-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "handig",
      "subSkill": "handig_optellen_aftrekken",
      "questionType": "fill_in",
      "question": "Reken handig uit met splitsen: 67 + 25 = ___",
      "options": [],
      "correctAnswer": "92",
      "data": {
        "acceptedAnswers": ["92"]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "splitDiagram",
          "showWhen": "wrong",
          "data": {
            "original": 25,
            "parts": [{ "value": 20, "label": "tientallen" }, { "value": 5, "label": "eenheden" }],
            "operation": "add",
            "operand": 67,
            "result": 92,
            "label": "Splits 25 in 20 + 5"
          }
        }
      ],
      "conceptId": "handig_splitsen_optellen_67_25",
      "variantIndex": 8,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "Splits 25 in 20 + 5. Eerst 67 + 20 = 87, dan 87 + 5 = 92. Door te splitsen reken je in twee makkelijke stappen.",
        "solutionSteps": [
          "Splits het tweede getal: 25 = 20 + 5",
          "Stap 1: 67 + 20 = 87",
          "Stap 2: 87 + 5 = 92"
        ]
      }
    },
    {
      "id": "REK-HANDIG-PLUS-MIN-009",
      "familyId": "REK-HANDIG-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "handig",
      "subSkill": "handig_optellen_aftrekken",
      "questionType": "step_solver",
      "question": "Reken handig uit met compenseren: 197 + 68. Los stap voor stap op.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "steps": [
          { "prompt": "Welk getal ligt dicht bij een rond getal?", "correctAnswer": "197", "hint": "197 is bijna 200." },
          { "prompt": "Rond af en reken: 200 + 68 = ?", "correctAnswer": "268", "hint": "200 + 68 = 268" },
          { "prompt": "Hoeveel heb je te veel opgeteld?", "correctAnswer": "3", "hint": "200 − 197 = 3, dus je telde 3 te veel op." },
          { "prompt": "Corrigeer: 268 − 3 = ?", "correctAnswer": "265", "hint": "268 − 3 = 265" }
        ],
        "finalAnswer": "265"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Compenseren", "content": "197 is bijna 200. Reken: 200 + 68 = 268. Je telde 3 te veel op (200 − 197 = 3). Corrigeer: 268 − 3 = 265.", "icon": "lightbulb" } }
      ],
      "conceptId": "handig_compenseren_step_solver",
      "variantIndex": 9,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "197 is bijna 200 — compenseren! Stap 1: 200 + 68 = 268. Stap 2: Je telde 3 te veel op (200 − 197 = 3). Stap 3: 268 − 3 = 265.",
        "solutionSteps": [
          "Herken: 197 ≈ 200 → compenseren",
          "200 + 68 = 268",
          "Te veel opgeteld: 200 − 197 = 3",
          "268 − 3 = 265"
        ]
      }
    },
    {
      "id": "REK-HANDIG-PLUS-MIN-010",
      "familyId": "REK-HANDIG-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "handig",
      "subSkill": "handig_optellen_aftrekken",
      "questionType": "true_false_series",
      "question": "Zijn deze manieren van handig rekenen juist of onjuist?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          {
            "text": "Om 48 + 39 uit te rekenen, kun je 48 + 40 doen en dan 1 aftrekken.",
            "isTrue": true,
            "explanation": "Dit is compenseren. 39 is 40 - 1. Dus 48 + 40 = 88, en 88 - 1 = 87."
          },
          {
            "text": "Om 73 - 28 uit te rekenen, kun je 73 - 30 doen en dan 2 aftrekken.",
            "isTrue": false,
            "explanation": "Je trekt 30 af (dat is 2 te veel), dus je moet er 2 bij optellen, niet aftrekken! 73 - 30 = 43, en 43 + 2 = 45."
          },
          {
            "text": "Om 56 + 25 uit te rekenen, kun je 56 + 20 doen en dan 5 erbij optellen.",
            "isTrue": true,
            "explanation": "Dit is splitsen. Je splitst 25 in 20 en 5. 56 + 20 = 76, en 76 + 5 = 81."
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Compenseren en Splitsen",
            "content": "Bij compenseren (bijv. + 39) tel je een rond getal op (+ 40) en corrigeer je (- 1). Bij aftrekken (bijv. - 28) trek je een rond getal af (- 30) en corrigeer je door erbij op te tellen (+ 2).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_plus_min_tf_series",
      "variantIndex": 10,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.75,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "Bij compenseren moet je goed opletten of je te veel hebt opgeteld of afgetrokken. Als je 30 aftrekt in plaats van 28, heb je 2 te veel afgetrokken, dus moet je die er weer bij doen (+ 2).",
        "solutionSteps": [
          "Stelling 1: 48 + 39 = 48 + 40 - 1 (Juist)",
          "Stelling 2: 73 - 28 = 73 - 30 + 2 (Onjuist, er staat - 2)",
          "Stelling 3: 56 + 25 = 56 + 20 + 5 (Juist)"
        ]
      }
    }
  ]
}